import React, { useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, TextLink } from "@vds/buttons";
import { Grid, Row, Col } from "@vds/grids";
import { Body } from "@vds/typography";

import { CloseIcon } from "../../../../common/components";
import { getProductType } from "../../../../utils/productTypeUtil";
import {
  getCompareDevices,
  setCompareDevices,
  setOneTalk,
} from "../../ducks/MobilitySlice";

import styled from "styled-components";
import { useImageUtils } from "hooks";
import { Carousel } from "@vds/carousels";
import { useMediaQuery } from "react-responsive";
import { Title } from "@vds/typography";
import { ellipsisShorten } from "../../../../utils/commonUtils";
const CompareTile = (props) => {
  const { getImageLink } = useImageUtils();
  return (
    <CompareTileContainer
      style={{
        backgroundColor: props.item?.deviceId ? "#f6f6f6" : "#ffffff",
        borderColor: props.item?.deviceId ? "#f6f6f6" : "#A7A7A7",
        border: props.item?.deviceId ? "none" : "1px dashed",
      }}
    >
      {props.item?.deviceId && (
        <>
          <CompareTileContent>
            <img
              width="90px"
              height="90px"
              src={getImageLink(props.item?.selectedSku?.filePath, 250, 250)}
            />
            <CompareTileText>
              <Body size="large">
                {ellipsisShorten(
                  props.item?.brandName + " " + props.item?.name,
                  23
                )}
              </Body>
            </CompareTileText>
          </CompareTileContent>
          <CloseIconContainer>
            <CloseIcon
              onClickFn={() => props.onCloseFn(props.item?.deviceId)}
            />
          </CloseIconContainer>
        </>
      )}
      {!props.item?.deviceId && (
        <CompareTileContentNew>
          <div className="WithoutCt">
            {props.index === props.count && <p>Add device</p>}
          </div>
          <CompareTileText />
        </CompareTileContentNew>
      )}
    </CompareTileContainer>
  );
};

const GridwallCompare = ({
  aem,
  selectedProducts = [],
  tileCloseFn,
  count,
  onClearFn,
  isOneTalk,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({
    query: "(max-width: 545px)",
  });
  const [isVisible, setIsVisible] = useState(true);
  const selectedKeys = Object.keys(selectedProducts ?? {});
  const selectedProductsArr = useMemo(() => {
    let arr = Object.values(selectedProducts || []);
    while (arr.length <= 4) {
      arr.push(1);
    }
    return arr;
  }, [selectedProducts]);

  const handleCompareBtnClick = () => {
    const productType = getProductType();
    if (isOneTalk) {
      dispatch(setOneTalk(true));
      dispatch(getCompareDevices());
      navigate(`/shop/products/voice-collaboration/${productType}/compare`);
    } else {
      dispatch(getCompareDevices());
      navigate(`/shop/products/devices/${productType}/compare`);
    }
  };

  const clearFun = () => {
    setIsVisible(false);
    if (onClearFn) {
      onClearFn();
    } else dispatch(setCompareDevices());
    setIsVisible(true);
  };
  const getCompareTile = (item) => {
    let regex = /\d/;
    const component = (
      <CompareTile
        key={item?.deviceId ?? String(item?.ariaLabel).match(regex)[0] - 1}
        item={item}
        onCloseFn={tileCloseFn}
        index={String(item?.ariaLabel).match(regex)[0] - 1}
        count={count}
      />
    );
    return component;
  };

  return isVisible && selectedKeys?.length ? (
    <Grid>
      <Row>
        <Col colSizes={{ mobile: 6, tablet: 12, desktop: 12 }}>
          <CompareHeading>
            {count > 0 ? (
              <>
                <Title size="small" bold>
                  {aem?.labels?.compareDevices}{" "}
                  <span style={{ fontWeight: "400" }}>({count})</span>
                </Title>
              </>
            ) : (
              ""
            )}
          </CompareHeading>
          <CompareContainer>
            <>
              {!isMobile ? (
                <>
                  {Array(4)
                    .fill(1)
                    .map((item, index) => (
                      <CompareTile
                        key={
                          selectedProducts[selectedKeys[index]]?.deviceId ??
                          index
                        }
                        item={selectedProducts[selectedKeys[index]]}
                        onCloseFn={tileCloseFn}
                        index={index}
                        count={count}
                      />
                    ))}
                </>
              ) : (
              <CarouselContainer>
              <Carousel
                layout={"2UP"}
                peek="minimum"
                aspectRatio="none"
                gutter="16px"
                surface="light"
                paginationFill="light"
                paginationDisplay="persistent"
                paginationInset="12px"
                data={selectedProductsArr}
                renderItem={(props) => {
                  return getCompareTile(props);
                }}
              />
              </CarouselContainer>)}
            </>
            <ButtonWrapper>
              <CompareButton
                size="large"
                use="secondary"
                disabled={selectedKeys?.length < 2}
                onClick={handleCompareBtnClick}
              >
                {aem?.labels?.compare ?? "Compare"}
              </CompareButton>
              <ClearAll>
                <TextLink
                  type="standAlone"
                  size="small"
                  role="button"
                  onClick={clearFun}
                >
                  {aem?.labels?.close123 ?? "Clear all"}
                </TextLink>
              </ClearAll>
            </ButtonWrapper>
          </CompareContainer>
        </Col>
      </Row>
    </Grid>
  ) : (
    <></>
  );
};

const CompareButton = styled(Button)`
  height: 2.9rem;
  width: 11.5rem;
  @media (max-width: 767px) {
     {
      margin-right: 35% !important;
    }
  }
`;

const CompareContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 2;
  max-width: 1273px;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 545px) {
     {
      display: flex;
      flex-direction: column;
    }
  }
`;
const CloseIconContainer = styled.div`
  @media (max-width: 767px) {
    position: absolute;
    right: 0;
    top: 0;
    padding: 1px;
    font-size: 16px;
  }
`;

const ClearAll = styled.div`
  margin-top: 0.6rem;
  a {
    margin-top: 7%;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  min-width: 100px;
  max-width: 20% !important;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 10px;

  @media (max-width: 767px) {
    max-width: 100% !important;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
    align-content: stretch;
    align-items: baseline;
    justify-content: space-around;
  }
`;

const CompareTileContainer = styled.div`
  max-width: 95%;
  padding: 15px;
  flex: 1;
  margin:5px !important;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  height: 100px;
  border-radius: 8px;
  margin-right: 1rem;
  background-color:#f6f6f6;
  border: 1px dashed #f6f6f6;
  box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.02);
  @media (max-width: 767px) {
     {
      min-width: 152px;
      max-height: 64px;
      border-radius: 8px;
      position: relative;
      top: 8px;
      display: flex;
      align-items: center;
      border: none;
}
    }
  }
`;

const CompareTileContentNew = styled.div`
  display: flex;
  margin: 5px;
  background-color: #ffffff !important;
  img {
    height: 48px;
    width: 48px;
  }
  @media (max-width: 767px) {
    .WithoutCt {
      position: absolute !important;
      top: 10px !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      left: 25px;
    }
  }
`;
const CompareTileContent = styled.div`
  background-color: #f6f6f6 !important;
  display: flex;
  align-items: flex-start;
  margin: 5px;
  img {
    height: 48px;
    width: 48px;
  }

  @media (max-width: 767px) {
    margin: -5px !important;
    img {
      max-width: 100%;
      width: 28px;
      height: 28px;
      object-fit: contain;
      position: absolute;
      top: 10px;
      left: 5px;
    }
  }
`;
const CompareTileText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 5px !important;

  @media (max-width: 767px) {
    font-family: "Verizon NHG eTX";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    width: 78px;
    height: 48px;
    margin-left: 32px !important;
    position: absolute;
    top: 7px;
    left: 10px;
  }
`;
const CompareHeading = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 1rem;
`;

const CarouselContainer = styled.div`

 @media (max-width: 767px)  {
 .right-pagination-control{
    position: absolute;
    right: 32%;
 }
 .slotContainer {
     display: flex;
    flex: 0 0 152px;
 }

  [class^=ScrollbarWrapper]{
    display: flex
    justify-content: center;
    flex-direction: row;
    flex: 1;
    max-width: 70% !important;
  }
`
export default GridwallCompare;
